import './canvas-tooltip.scss'
import canvasTooltip from './canvasTooltip'

export default canvasTooltip
